var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 358,
    viewBox: "0 0 270 358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-28.5619 46.8838C24.1903 -1.07994 97.8077 -11.4403 159.508 14.2063C95.0195 110.937 100.945 242.342 180.935 333.256C109.773 374.965 16.8187 362.62 -40.7896 299.004C-106.894 226.006 -101.426 113.124 -28.5619 46.8838Z",
    fill: "#E94444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.508 14.2063C183.025 23.9762 204.818 38.9782 223.059 59.1248C289.168 132.128 283.701 245.01 210.836 311.25C201.468 319.768 191.433 327.105 180.93 333.256C100.945 242.342 95.0193 110.937 159.508 14.2063Z",
    fill: "#46B6E7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfCircle);
export default __webpack_public_path__ + "static/media/halfCircle.3324bf4ac0422e11f55c4a5c191db692.svg";
export { ForwardRef as ReactComponent };